<template>
    <form
        :action="autocompleteUrl"
        method="get"
        accept-charset="utf-8"
        class="c-search__form"
        @submit.prevent="search"
    >
        <button
            type="button"
            :class="{ 'is-visible': keyword && isFormVisible }"
            :tabindex="keyword ? '0' : '-1'"
            class="c-search__clear c-btn js-header-actions-tippy"
            :data-tippy-content="$t('Autocomplete.Form.clearSearchPhrase')"
            @click.prevent="clear()"
        >
            <i class="ico ico-cross"></i>
        </button>

        <input
            :id="'autocomplete-' + parseInt(Math.random() * 1000)"
            ref="searchInput"
            type="text"
            :value="keyword"
            name="search"
            autocomplete="off"
            :placeholder="inputPlaceholder"
            class="c-search__input"
            :class="{
                'is-empty': !keyword,
                'has-clear-visible': keyword && isFormVisible,
                'is-form-visible': isFormVisible,
                'is-open': isOpen,
            }"
            @input="onInput"
            @focus="showForm"
            @keyup.enter="redirectToSearch"
        />

        <a
            :href="searchUrl"
            class="c-search__btn c-btn c-btn--secondary cxs-is-hidden xs-is-hidden"
            :class="{ 'is-loading': isLoading }"
        >
            <i class="ico ico-search"></i>
        </a>

        <button
            type="button"
            class="c-search__btn c-btn c-btn--close cxs-is-visible xs-is-visible js-header-actions-tippy"
            :data-tippy-content="$t('Autocomplete.Form.closeAutocomplete')"
            :class="{ 'is-loading': isLoading }"
            @click.prevent="hideForm"
        >
            <i aria-hidden="true" class="ico ico-cross"></i>
        </button>
    </form>
</template>

<script>
import RshopAutocompleteForm from "FrontendComponents/Autocomplete/Form/index.vue";
import { initHeaderActionTippy } from "Functions/tippy";

export default {
    extends: RshopAutocompleteForm,
    props: {
        isFormVisible: {
            type: Boolean,
            default: false,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        inputPlaceholder: {
            type: String,
            required: true,
        },
    },
    computed: {
        searchUrl() {
            return `/vyhladavanie${this.keyword ? `?search=${this.keyword}` : ""}`;
        },
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                this.focusInput();
            }
        },
        categoryId() {
            if (this.keyword) {
                this.search();
            }
        },
        // toto je skaredy ojeb, no, nechcelo sa mi uz stacat cas
        isLoading(value) {
            this.$parent.isLoading = value;
        },
    },
    mounted() {
        this.$nextTick(() => {
            initHeaderActionTippy();
        });
    },
    methods: {
        showForm() {
            this.$emit("show-form");
        },
        hideForm() {
            this.$emit("hide-form");
        },
        hideResults() {
            this.$emit("hide-results");
        },
        clear() {
            this.keyword = "";
            this.hideResults();
            this.focusInput();

            this.$emit("reset-matches");
        },
        focusInput() {
            this.$nextTick(() => {
                this.$refs.searchInput.focus();
            });
        },
        onInput(event) {
            this.keyword = event.target.value;

            this.search();
        },
        redirectToSearch() {
            window.location.href = this.searchUrl;
        },
    },
};
</script>
